<template>
    <article class="c-usage">
        <div
            class="c-usage__box"
            v-view.once
        >
            <header
                v-if="title"
                class="c-usage__header"
            >
                <h2 class="t-t2">{{ title }}</h2>
            </header>
            <div class="c-usage__content">
                <div
                    v-if="body"
                    class="t-cms"
                    v-html="body"
                ></div>
                <ol class="c-usage__list | o-usage-list">
                    <li
                        v-for="step in steps"
                        :key="step.col1"
                        class="o-usage-list__item"
                        :class="`is-${step.state}`"
                    >
                        <Icon
                            v-if="step.state === STATES.CHECKED"
                            class="o-usage-list__icon"
                            icon="check"
                        />
                        <Icon
                            v-if="step.state === STATES.CURRENT"
                            class="o-usage-list__icon"
                            icon="arrow-circle"
                        />
                        <span class="o-usage-list__label">{{ step.label }}</span>
                    </li>
                </ol>
            </div>
        </div>
        <div
            v-if="asset"
            class="c-usage__asset"
            v-view.once
        >
            <Img
                :data-src="asset.url"
                :alt="asset.title"
                :width="asset.width"
                :height="asset.height"
            ></Img>
            <ul class="o-usage-pickers">
                <li
                    v-for="picker in pickers"
                    class="o-usage-pickers__item"
                >
                    <Icon
                        icon="picker"
                    />
                    <Rounded
                        class="o-rounded--xs"
                    >
                        {{ picker.label }}%
                    </Rounded>
                </li>
            </ul>
        </div>
    </article>
</template>

<script>
import Img from 'templates/objects/Img';
import Icon from 'templates/objects/Icon';
import Rounded from 'templates/objects/Rounded';

const STATES = {
    CHECKED: 'CHECKED',
    CURRENT: 'CURRENT',
};

export default {
    name: 'Usage',
    components: {
        Img,
        Icon,
        Rounded,
    },
    data() {
        return {
            STATES,
            pickers: [
                { label: 97 },
                { label: 42 },
                { label: 92 },
                { label: 86 },
                { label: 82 },
                { label: 77 },
            ],
        };
    },
    props: {
        title: {
            type: String,
        },
        body: {
            type: String,
        },
        steps: {
            type: Array,
        },
        asset: {
            type: Object,
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
